// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShiftsPage_page__lkBl7 {
  position: relative;
  display: grid;
  gap: 14px;
  padding: 12px;
}

.ShiftsPage_headerRow__Eu89w {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.ShiftsPage_weekNav__lTbAx {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.ShiftsPage_weekTitle__Zd1\\+R {
  font-weight: 700;
}

.ShiftsPage_summaryGrid__L5bW0 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.ShiftsPage_summaryCard__jwLIw {
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 16px;
  background: var(--cl-surface, #fff);
  padding: 16px;
}

.ShiftsPage_summaryCard__jwLIw h2 {
  margin: 0 0 12px;
  font-size: 18px;
}

.ShiftsPage_pillList__F5P0j {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ShiftsPage_pill__LedZ9 {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  border-radius: 999px;
  background: #eef5ff;
  color: #1565c0;
  padding: 0 12px;
  font-weight: 600;
}

.ShiftsPage_changeList__TPWAC,
.ShiftsPage_exceptionsGrid__dCK5u {
  display: grid;
  gap: 10px;
}

.ShiftsPage_changeItem__aRqum,
.ShiftsPage_exceptionCard__AspaL {
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 14px;
  background: var(--cl-surface-2, #f7f9fc);
  padding: 12px;
}

.ShiftsPage_changeItem__aRqum,
.ShiftsPage_exceptionRow__wKp5i,
.ShiftsPage_userCell__g4PRT,
.ShiftsPage_exceptionHeader__R5zLl {
  display: grid;
  gap: 6px;
}

.ShiftsPage_tableWrap__zX7BY {
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 16px;
  overflow: auto;
  background: var(--cl-surface, #fff);
}

.ShiftsPage_table__xA70l {
  width: 100%;
  border-collapse: collapse;
  min-width: 1220px;
}

.ShiftsPage_table__xA70l th,
.ShiftsPage_table__xA70l td {
  border-bottom: 1px solid var(--cl-border, #d8dde6);
  padding: 12px;
  vertical-align: top;
}

.ShiftsPage_table__xA70l th {
  background: var(--cl-surface-2, #f7f9fc);
  text-align: left;
  font-weight: 700;
}

.ShiftsPage_userCell__g4PRT span,
.ShiftsPage_exceptionRow__wKp5i span,
.ShiftsPage_changeItem__aRqum span {
  color: var(--cl-dark, #5f6b7a);
}

.ShiftsPage_shiftCell__I73Rn {
  min-width: 160px;
}

.ShiftsPage_shiftLabel__zTb8M {
  font-weight: 600;
  margin-bottom: 8px;
}

.ShiftsPage_editor__5Irgq {
  display: grid;
  gap: 8px;
}

.ShiftsPage_checkboxRow__Jt0T4 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.ShiftsPage_timeRow__xaYa- {
  display: flex;
  gap: 8px;
}

.ShiftsPage_timeRow__xaYa- input {
  width: 100%;
}

.ShiftsPage_actionsCell__i5hU8 {
  display: grid;
  gap: 8px;
  min-width: 160px;
}

.ShiftsPage_exceptionsGrid__dCK5u {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.ShiftsPage_exceptionHeader__R5zLl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.ShiftsPage_exceptionHeader__R5zLl button,
.ShiftsPage_exceptionRow__wKp5i button {
  border: none;
  background: transparent;
  color: #1677ff;
  cursor: pointer;
  padding: 0;
}

.ShiftsPage_exceptionRow__wKp5i {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: start;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid var(--cl-border, #d8dde6);
}

.ShiftsPage_emptyText__p-jEM,
.ShiftsPage_emptyCell__SH8O- {
  color: var(--cl-dark, #5f6b7a);
  opacity: 0.8;
}

.ShiftsPage_emptyCell__SH8O- {
  text-align: center;
}

.ShiftsPage_modalContent__uP54w {
  width: min(520px, 100vw - 24px);
  margin: 10vh auto 0;
  border-radius: 16px;
  background: var(--cl-surface, #fff);
  padding: 20px;
  outline: none;
}

.ShiftsPage_modalField__l5WZG {
  display: grid;
  gap: 8px;
  margin-bottom: 14px;
}

.ShiftsPage_modalField__l5WZG label {
  font-weight: 700;
}

.ShiftsPage_modalActions__2KW8h {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

@media (max-width: 1100px) {
  .ShiftsPage_summaryGrid__L5bW0,
  .ShiftsPage_exceptionsGrid__dCK5u {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .ShiftsPage_page__lkBl7 {
    padding: 8px;
  }
  .ShiftsPage_headerRow__Eu89w,
  .ShiftsPage_weekNav__lTbAx,
  .ShiftsPage_timeRow__xaYa-,
  .ShiftsPage_modalActions__2KW8h,
  .ShiftsPage_exceptionRow__wKp5i,
  .ShiftsPage_exceptionHeader__R5zLl {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ShiftsPage/ShiftsPage.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,2CAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,SAAA;AACF;;AAEA;;EAEE,2CAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;AACF;;AAEA;;;;EAIE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,kDAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;;;EAGE,8BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;;EAEE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+CAAA;AACF;;AAEA;;EAEE,8BAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,+BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AACF;;AAEA;EACE;;IAEE,0BAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;EAAF;EAGA;;;;;;IAME,sBAAA;IACA,oBAAA;EADF;AACF","sourcesContent":[".page {\n  position: relative;\n  display: grid;\n  gap: 14px;\n  padding: 12px;\n}\n\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.weekNav {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.weekTitle {\n  font-weight: 700;\n}\n\n.summaryGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.summaryCard {\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 16px;\n  background: var(--cl-surface, #fff);\n  padding: 16px;\n}\n\n.summaryCard h2 {\n  margin: 0 0 12px;\n  font-size: 18px;\n}\n\n.pillList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  border-radius: 999px;\n  background: #eef5ff;\n  color: #1565c0;\n  padding: 0 12px;\n  font-weight: 600;\n}\n\n.changeList,\n.exceptionsGrid {\n  display: grid;\n  gap: 10px;\n}\n\n.changeItem,\n.exceptionCard {\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 14px;\n  background: var(--cl-surface-2, #f7f9fc);\n  padding: 12px;\n}\n\n.changeItem,\n.exceptionRow,\n.userCell,\n.exceptionHeader {\n  display: grid;\n  gap: 6px;\n}\n\n.tableWrap {\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 16px;\n  overflow: auto;\n  background: var(--cl-surface, #fff);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1220px;\n}\n\n.table th,\n.table td {\n  border-bottom: 1px solid var(--cl-border, #d8dde6);\n  padding: 12px;\n  vertical-align: top;\n}\n\n.table th {\n  background: var(--cl-surface-2, #f7f9fc);\n  text-align: left;\n  font-weight: 700;\n}\n\n.userCell span,\n.exceptionRow span,\n.changeItem span {\n  color: var(--cl-dark, #5f6b7a);\n}\n\n.shiftCell {\n  min-width: 160px;\n}\n\n.shiftLabel {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.editor {\n  display: grid;\n  gap: 8px;\n}\n\n.checkboxRow {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.timeRow {\n  display: flex;\n  gap: 8px;\n}\n\n.timeRow input {\n  width: 100%;\n}\n\n.actionsCell {\n  display: grid;\n  gap: 8px;\n  min-width: 160px;\n}\n\n.exceptionsGrid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.exceptionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.exceptionHeader button,\n.exceptionRow button {\n  border: none;\n  background: transparent;\n  color: #1677ff;\n  cursor: pointer;\n  padding: 0;\n}\n\n.exceptionRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: start;\n  padding-top: 10px;\n  margin-top: 10px;\n  border-top: 1px solid var(--cl-border, #d8dde6);\n}\n\n.emptyText,\n.emptyCell {\n  color: var(--cl-dark, #5f6b7a);\n  opacity: 0.8;\n}\n\n.emptyCell {\n  text-align: center;\n}\n\n.modalContent {\n  width: min(520px, calc(100vw - 24px));\n  margin: 10vh auto 0;\n  border-radius: 16px;\n  background: var(--cl-surface, #fff);\n  padding: 20px;\n  outline: none;\n}\n\n.modalField {\n  display: grid;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.modalField label {\n  font-weight: 700;\n}\n\n.modalActions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n@media (max-width: 1100px) {\n  .summaryGrid,\n  .exceptionsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 760px) {\n  .page {\n    padding: 8px;\n  }\n\n  .headerRow,\n  .weekNav,\n  .timeRow,\n  .modalActions,\n  .exceptionRow,\n  .exceptionHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ShiftsPage_page__lkBl7`,
	"headerRow": `ShiftsPage_headerRow__Eu89w`,
	"weekNav": `ShiftsPage_weekNav__lTbAx`,
	"weekTitle": `ShiftsPage_weekTitle__Zd1+R`,
	"summaryGrid": `ShiftsPage_summaryGrid__L5bW0`,
	"summaryCard": `ShiftsPage_summaryCard__jwLIw`,
	"pillList": `ShiftsPage_pillList__F5P0j`,
	"pill": `ShiftsPage_pill__LedZ9`,
	"changeList": `ShiftsPage_changeList__TPWAC`,
	"exceptionsGrid": `ShiftsPage_exceptionsGrid__dCK5u`,
	"changeItem": `ShiftsPage_changeItem__aRqum`,
	"exceptionCard": `ShiftsPage_exceptionCard__AspaL`,
	"exceptionRow": `ShiftsPage_exceptionRow__wKp5i`,
	"userCell": `ShiftsPage_userCell__g4PRT`,
	"exceptionHeader": `ShiftsPage_exceptionHeader__R5zLl`,
	"tableWrap": `ShiftsPage_tableWrap__zX7BY`,
	"table": `ShiftsPage_table__xA70l`,
	"shiftCell": `ShiftsPage_shiftCell__I73Rn`,
	"shiftLabel": `ShiftsPage_shiftLabel__zTb8M`,
	"editor": `ShiftsPage_editor__5Irgq`,
	"checkboxRow": `ShiftsPage_checkboxRow__Jt0T4`,
	"timeRow": `ShiftsPage_timeRow__xaYa-`,
	"actionsCell": `ShiftsPage_actionsCell__i5hU8`,
	"emptyText": `ShiftsPage_emptyText__p-jEM`,
	"emptyCell": `ShiftsPage_emptyCell__SH8O-`,
	"modalContent": `ShiftsPage_modalContent__uP54w`,
	"modalField": `ShiftsPage_modalField__l5WZG`,
	"modalActions": `ShiftsPage_modalActions__2KW8h`
};
export default ___CSS_LOADER_EXPORT___;
